import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_vmtc7qy6f3: FaireBrandEntity = {
  token: "b_vmtc7qy6f3",
  type: "brand",
  name: "Blackberry Hill Apothecary",
  avatarUrl:
    "https://cdn.faire.com/fastly/bf93274b3a2aba7294f7780441910a149f8fd3615e9e0b282249bf02894dd8e7.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/5cf49f77f83d34bf9987c2388718fb9d285e893bc63ec4a6eea7420be84dfb06.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/bf93274b3a2aba7294f7780441910a149f8fd3615e9e0b282249bf02894dd8e7.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5cf49f77f83d34bf9987c2388718fb9d285e893bc63ec4a6eea7420be84dfb06.jpeg",
  location: "Newtown, PA, USA",
  minimumOrderDollars: 50,
  rating: 5,
  reviewCount: 26,
  isTopShop: true,
  isInsider: true,
  description:
    "Blackberry Hill is a woman-owned apothecary brand creating nature-inspired, non-toxic essentials. \n\nFounded by a product innovator with a deep respect for formulation, function, and integrity, Blackberry Hill was born from both professional expertise and personal experience. During a breast cancer journey, the need for truly clean, effective products became urgent—products that could help soothe pain, support the body, and remove unnecessary toxins from the home without sacrificing beauty or performance.\n\nEvery formula is handcrafted in small batches using thoughtfully sourced botanicals, time-honored ingredients, and evidence-informed methods. Rooted in generations of passed-down knowledge and supported by modern research, our products are designed to nourish, protect, and restore—skin, body, and home alike.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:36.673Z",
    importedBy: "entity-db-cli",
  },
};
